import React, { Component } from 'react';


import domtoimage from 'dom-to-image';
// import saveAs from 'file-saver';


import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DoughnutDB from './DoughnutDB';
import BarsTenDB from './CleanBarTenDB';
// import MatrixDB from './MatrixDB';
// import AreaDB from './AreaDB';
// import NegativeDB from './NegativeDB';
// import TopDB from './TopDB';
import DetailLineDB from './DetailLineDB';
import IconButton from '@material-ui/core/IconButton';
// import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Clear';
import DownloadIcon from '@material-ui/icons/GetApp';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { colors } from '../../../constants/icons/characteristics/Characteristics';
import './../../selections/timeSelection/components/timeSelect/cliente.css';


//Actualizacion develop
class DialogDB extends Component {

  setDataGraphics = () => {
    // let data = this.props.detailData;
  }

  handleDoughut = (graphicName) => {
    if (typeof graphicName === "undefined") {
      return <></>
    }
    if (Object.keys(graphicName).length === 0) {
      return <></>
    }
    return graphicName.dataSetDon.filter((val) => {
      if (val.dataSet.length === 0)
        return false;
      return true;
    }).map((val) => {
      return (
        <Grid className='chartColList' item xs={12} lg={6}>
          <DoughnutDB
            name={val.name}
            title={''}
            data={val.dataSet}
            colors={colors}
            watchMenu={false}
          />
        </Grid>
      )
    });
  }

  // handleMatrix = (graphicName) => {
  //     if (typeof graphicName === "undefined" || graphicName === null) {
  //         return <></>
  //     }
  //     if (typeof graphicName.data === "undefined" || graphicName.data === null) {
  //         return (<></>);
  //     }
  //     return graphicName.data.dataSetMatriz.filter((val) => {
  //         if (val.dataSet.length === 0)
  //             return false;
  //         return true;
  //     }).map((val, index) => {
  //         return (
  //             <Grid className='chartColList' item xs={12} lg={6} key={'grid-ver-matrix-' + index}>
  //                 <MatrixDB
  //                     name={val.name}
  //                     title={val.title}
  //                     data={this.GetDataMatrix(val.dataSet)}
  //                     openDialog={this.props.openDialog}
  //                     onClickGraphic={this.props.onClickGraphic}
  //                     watchMenu={false}
  //                 />
  //             </Grid>

  //         )
  //     });
  // }

  // handleArea = (graphicName) => {
  //     if (typeof graphicName.data === "undefined") {
  //         return (<div></div>);
  //     }
  //     let total = graphicName.data.dataSetEdad.reduce((tot, cv) => (tot + cv));
  //     if (total === 0) {
  //         return (<div></div>);
  //     }
  //     return (
  //         <Grid className='chartColList' item xs={12} lg={6}>
  //             <AreaDB
  //                 name={'area'}
  //                 title={'Edad'}
  //                 data={graphicName.data.dataSetEdad}
  //                 openDialog={this.props.openDialog}
  //                 onClickGraphic={this.props.onClickGraphic}
  //                 watchMenu={false}
  //             />
  //         </Grid>
  //     )
  // }
  // handleNegative = (graphicName) => {
  //     if (typeof graphicName.data === "undefined") {
  //         return (<div></div>);
  //     }
  //     if (graphicName.data.dataSetBarsTime.length === 0) {
  //         return (<div></div>);
  //     }
  //     return (
  //         <Grid className='chartColList' item xs={12} lg={6}>
  //             <NegativeDB
  //                 name={'negativo'}
  //                 title={'Horas'}
  //                 data={graphicName.data.dataSetBarsTime}
  //                 openDialog={this.props.openDialog}
  //                 onClickGraphic={this.props.onClickGraphic}
  //                 watchMenu={false}
  //             />
  //         </Grid>
  //     )
  // }

  // handleTop = (graphicName) => {
  //     if (typeof graphicName.data === "undefined") {
  //         return (<div></div>);
  //     }
  //     return graphicName.data.dataSetTop5.filter((val) => {
  //         if (val.dataSet.length === 0) {
  //             return false;
  //         }
  //         return true;
  //     }).map((val) => {
  //         return (
  //             <Grid className='chartColList' item xs={12} lg={6}>
  //                 <TopDB
  //                     name={val.name}
  //                     title={val.title}
  //                     data={val.dataSet}
  //                     openDialog={this.props.openDialog}
  //                     onClickGraphic={this.props.onClickGraphic}
  //                     watchMenu={false}
  //                 />
  //             </Grid>
  //         )
  //     });
  // }



  handleBarTen = (graphicName) => {
    if (typeof graphicName === "undefined") {
      return <></>
    }
    if (Object.keys(graphicName).length === 0) {
      return <></>
    }
    if (graphicName.dataSetTenBars === undefined) return <></>
    console.log('gn', graphicName)
    return graphicName.dataSetTenBars.filter((val) => {
      if (val.dataSet.length === 0)
        return false;
      return true;
    }).map((val) => {
      return (
        <Grid className='chartColList' item xs={12} >
          <BarsTenDB
            name={val.name}
            title={val.title}
            data={val.dataSet}
            colors={colors}
            watchMenu={false}
          />
        </Grid>
      )
    });
  }

  handleDetailLine = (graphicName) => {
    if (Object.keys(graphicName).length === 0) return <></>
    if (graphicName.dataSetTimeLine === undefined) return <></>
    if (graphicName.dataSetTimeLine.length === 0) return <></>
    return graphicName.dataSetTimeLine[0].dataSet.map((val) => {
      return (
        <Grid className='chartColList' item xs={12} lg={6}>
          <DetailLineDB
            name={val.name}
            title={val.name}
            data={val.value}
            colors={colors}
            watchMenu={false}
          />
        </Grid>
      )
    });
  }

  // GetDataMatrix = (horas) => {
  //     let dias = [];
  //     if (horas.length < 7) {
  //         for (let i = 0; i < horas.length; i++) {
  //             let valor = {
  //                 horas: horas[i],
  //                 dia: ''
  //             }
  //             switch (i) {
  //                 case 0: valor.dia = 'M'; break;
  //                 case 1: valor.dia = 'M'; break;
  //                 case 2: valor.dia = 'T'; break;
  //                 default: valor.dia = 'N'; break;
  //             }
  //             dias.push(valor);
  //         }
  //     } else {
  //         for (let i = 0; i < horas.length; i++) {
  //             let valor = {
  //                 horas: horas[i],
  //                 dia: ''
  //             }
  //             switch (i) {
  //                 case 0: valor.dia = 'L'; break;
  //                 case 1: valor.dia = 'M'; break;
  //                 case 2: valor.dia = 'M'; break;
  //                 case 3: valor.dia = 'J'; break;
  //                 case 4: valor.dia = 'V'; break;
  //                 case 5: valor.dia = 'S'; break;
  //                 default: valor.dia = 'D'; break;
  //             }
  //             dias.push(valor);
  //         }
  //     }

  //     return dias;
  // }

  handleDownload = () => {
    var node = document.getElementById('verMas');
    node.classList.add('background-download-gr');
    var file = 'verMas';
    domtoimage.toBlob(node)
      .then(function (blob) {
        window.saveAs(blob, file + '.png');
        node.classList.remove('background-download-gr');
      });
  }
  render() {
    return (
      <Dialog

        open={this.props.open}
        fullWidth={true}
        maxWidth={"lg"}
        onClose={this.props.onClose}
        scroll={this.props.scroll}
        aria-labelledby="max-width-dialog-title"

      >
        <DialogTitle id="scroll-dialog-title" style={{ textAlign: 'right' }}>
          <Grid container>
            <Grid item xs={1}></Grid>
            <Grid item xs={10} className='text-center'>
              <button
                className='btnCharacteristicsOff'
                onClick={this.handleDownload}
              >
                <Grid className="btnIntern" >
                  <Grid className="btnIcon">
                    <DownloadIcon />
                  </Grid>
                  <Grid >
                    Descargar
                                </Grid>
                </Grid>
              </button>
            </Grid>
            <Grid item xs={1}>
              <IconButton
                aria-label="Cerrar"
                aria-haspopup="true"
                className="client-button-menu"
                onClick={this.props.onClose}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <div id='verMas'>
            <Grid container>
              <Grid item xs={12} >
                <h2 className="text-center client-label-second-color">{this.props.title}</h2>
              </Grid>
            </Grid>
            <Grid container>
              {
                this.handleDoughut(this.props.detailData)
              }
              {
                this.handleDetailLine(this.props.detailData)
              }
              {
                this.handleBarTen(this.props.detailData)
              }
              {
                // this.handleMatrix(this.props.detailData)
              }
              {
                // this.handleMatrix(this.props.detailData, 'dias-jornadas', 'Dias - Jornadas', 2)
              }
              {
                // this.handleArea(this.props.detailData)
              }
              {
                // this.handleNegative(this.props.detailData)
              }
              {
                // this.handleTop(this.props.detailData)
              }
            </Grid>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default DialogDB;